import React, { useContext } from 'react';
import { StateContext, actions as stateActions } from "../../state/index";
import errorImg from "../../assets/images/error-exclamation.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import styled from 'styled-components/macro';
import classnames from 'classnames';
import Title from "./Title";
import { useTranslation } from "react-i18next";
import ConfigComponent from "../ConfigComponent";
import Button, { ButtonContainer } from "./Buttons";
import StartOver from "./StartOver";

const StyledModal = styled.div`
  background: hsla(0, 0%, 0%, 0.90);
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  transition: opacity 1s;
`;

const StyledModalContent = styled.div`
  background: #f1f1f1;
  width: 75vw;
  max-width: 100%;
  overflow: auto;
  pointer-event: none;
  position: relative;
  display: flex;
  flex-direction: column;
  transition: all 1s;

  & ul {
    text-align: left;
    margin: auto;

    li {
      padding: 5px 0;
    }
  }

  @media only screen and (max-width : 500px) {
    width: 100vw;
  }
`;

const ModalClose = styled.div`
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  position: absolute;
  right: 1em;
  text-shadow: 2px 2px 0 rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  
  @media screen and (max-width: 500px) {
    right: 0.5em;
  }
`;

const ModalCloseButton = ({onClose, allowClose}) => {
  return allowClose ? (
    <ModalClose onClick={onClose}>
      <FontAwesomeIcon className="close-icon" icon={faTimesCircle} size="lg" />
    </ModalClose>
  ) : null;
};

const ModalContainer = styled.div`
  overflow-y: auto;
  position: relative;
`;

export const Modal = () => {
  const [{modals}, dispatch] = useContext(StateContext);

  if(!modals.length) {
    return null;
  }
  else{
    const modal = modals[modals.length - 1];
    const { content, title, icon, allowClose, onClose = () => {}, className } = modal;

    const onCloseModal = () => {
      if(allowClose){
        dispatch(stateActions.modals.popModal());
        onClose()
      }
    };

    return (
      <StyledModal className={classnames('modal', 'modal-background', className)} onClick={onCloseModal}>
        <ModalContainer className={classnames('modal-container')} onClick={evt => evt.stopPropagation()}>
          {title ? <Title>
            <h1>{title}</h1>{icon || null}
            {<ModalCloseButton onClose={onCloseModal} allowClose={allowClose} />}
          </Title> : <ModalCloseButton onClose={onCloseModal} allowClose={allowClose} />}
          <StyledModalContent className={classnames('modal-content', className)} onClick={evt => evt.stopPropagation()} allowClose={true} >
            {content}
          </StyledModalContent>
        </ModalContainer>
      </StyledModal>
    );
  }
};

export const ErrorModalContent = ({description, actions = [], imgSrc, showChooseAnotherNetwork = false, showFaqLink = true, className, onClose, buttonProps, dataForVariableSubstitutions = {}}) => {
  const [{configuration}, dispatch] = useContext(StateContext);
  const [t] = useTranslation();

  const retryAction = (onClick) => {
    dispatch(stateActions.modals.popModal());
    onClick();
  };

  return (
    <>
      <section className="main">
        <div className="description"><ConfigComponent config={description} data={dataForVariableSubstitutions}/></div>
        {onClose && <Button className="button-close btn-small" small onClick={() => {
          onClose();
          dispatch(stateActions.modals.popModal());
        }}>{t('buttons.ok')}</Button>}
        {
          (actions.length || (showFaqLink && configuration.faqs.length > 0) || showChooseAnotherNetwork) &&
          <>
            {
              actions.length > 0 &&
              <ButtonContainer>
                {actions.map((action, idx) => <Button key={idx} small onClick={() => retryAction(action.onClick)} {...buttonProps}><ConfigComponent config={action.label}/></Button>)}
              </ButtonContainer>
            }
            {showChooseAnotherNetwork && <StartOver/>}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            {(showFaqLink && configuration.faqs.length > 0) && <><hr style={{width: '100%'}}/><a style={{padding: '1em 0'}} onClick={() => dispatch(stateActions.modals.showFaqs())}>Check FAQs</a></>}
          </>
        }
      </section>
    </>
  );
};

export const ModalContent = ErrorModalContent;

export const ErrorModal = props => <ModalContent imgSrc={errorImg} {...props} />;

export default Modal;
